import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { Knowledge } from 'src/app/models/knowledge.model';

import {
  DomSanitizer,
  SafeUrl
} from '@angular/platform-browser';

import { HomeService } from 'src/app/services/home.service';
import { SeoService } from 'src/app/services/seo.service';

import {
  getLocalTranslate
} from 'src/app/helpers/global-functions';

@Component({
  selector: 'app-knowledge',
  templateUrl: './knowledge.component.html',
  styleUrls: ['./knowledge.component.css']
})
export class KnowledgeComponent implements OnInit {

  public htmlContent: string = '';

  knowledge: Knowledge = new Knowledge();

  relateds: Knowledge[] = [];

  cloneRelateds: Knowledge[] = [];

  imageUrl: SafeUrl;

  related: string = 'Other Knowledges';

  home: string = 'Home';

  knowledgeText: string = 'Knowledge';

  constructor(
    private route: ActivatedRoute,
    private firestore: AngularFirestore,
    private homeService: HomeService,
    private sanizer: DomSanitizer,
    private seoService: SeoService
  ) {

  }

  ngOnInit(): void {

    this.getKnowledge();

    this.getRelated();

    this.needTranslate();
  }

  needTranslate() {

    this.related =
      getLocalTranslate(
        'other-knowledges',
        this.related
      );

    this.home =
      getLocalTranslate(
        'home',
        this.home
      );

    this.knowledgeText =
      getLocalTranslate(
        'knowledge',
        this.knowledgeText
      );
  }

  getKnowledge() {

    const id =
      this.route.snapshot.params['id'];

    const id$ =
      new Subject<string>();

    const queryObservable =
      id$.pipe(
        switchMap(id =>
          this.firestore
            .collection('knowledges')
            .doc(id)
            .get()
        )
      );

    queryObservable.subscribe(
      queriedItem => {

        if (!queriedItem.exists) {
          return;
        }

        const knowledge: Knowledge =
          new Knowledge();

        knowledge.id =
          queriedItem.id;

        Object.assign(
          knowledge,
          queriedItem.data()
        );

        this.knowledge =
          knowledge;

        this.htmlContent =
          this.knowledge.descriptionEn;

        // ==========================================
        // Knowledge Image
        // ==========================================

        const image =
          this.knowledge.image &&
          this.knowledge.image.fileUrl
            ? this.knowledge.image.fileUrl
            : 'https://camedu-learning.com/assets/images/default-knowledge.jpg';

        this.imageUrl =
          this.sanizer
            .bypassSecurityTrustResourceUrl(image);

        // ==========================================
        // SEO
        // ==========================================

        const title =
          this.knowledge.titleEn ||
          'Knowledge | CamEdu';

        const description =
          this.knowledge.descriptionEn ||
          'Learn more English knowledge with CamEdu.';

        const pageUrl =
          'https://camedu-learning.com/knowledge/' +
          this.knowledge.id;

        this.seoService.setCourseSeo(
          title + ' | CamEdu',
          description,
          image,
          pageUrl
        );

        // ==========================================
      }
    );

    id$.next(id);
  }

  getRelated() {

    const id =
      this.route.snapshot.params['id'];

    this.homeService
      .getKnowledges(10)
      .then(result => {

        this.cloneRelateds =
          result;

        const relateds =
          result.filter(
            item => item.id !== id
          );

        this.relateds =
          relateds;
      });
  }

  onChooseKnowledge(knowledge: Knowledge) {

    this.knowledge =
      knowledge;

    this.htmlContent =
      this.knowledge.descriptionEn;

    const image =
      this.knowledge.image &&
      this.knowledge.image.fileUrl
        ? this.knowledge.image.fileUrl
        : 'https://camedu-learning.com/assets/images/default-knowledge.jpg';

    this.imageUrl =
      this.sanizer
        .bypassSecurityTrustResourceUrl(image);

    // ==========================================
    // Update SEO when changing knowledge
    // ==========================================

    const title =
      this.knowledge.titleEn ||
      'Knowledge | CamEdu';

    const description =
      this.knowledge.descriptionEn ||
      'Learn more English knowledge with CamEdu.';

    const pageUrl =
      'https://camedu-learning.com/knowledge/' +
      this.knowledge.id;

    this.seoService.setCourseSeo(
      title + ' | CamEdu',
      description,
      image,
      pageUrl
    );

    // ==========================================

    let relatedItem =
      this.cloneRelateds;

    relatedItem =
      relatedItem.filter(
        item =>
          item.id !== this.knowledge.id
      );

    this.relateds =
      relatedItem;
  }
}